import Pagination from "../../../../material/pagination/Pagination";
import PaginationConfig from "../../../../material/pagination/PaginationConfig";
import route from "../../../../enum/route";
import Operator from "../../../../material/pagination/Operator";
import Intervention from "../../../../entity/insurance/Intervention";
import PaginationColumn from "../../../../material/pagination/PaginationColumn";
import InterventionUtils from "../../../../entity/utils/insurance/InterventionUtils";
import Type from "../../../../material/pagination/Type";
import EnumConfig from "../../../../material/pagination/EnumConfig";
import EnumOption from "../../../../material/pagination/EnumOption";
import {useNavigate} from "react-router";
import OrderBy from "../../../../material/pagination/OrderBy";

export default function ({companyId}) {
    const navigate = useNavigate();

    return (
        <Pagination
            paginationConfig={
                new PaginationConfig()
                    .setId("intervention-list-insurance")
                    .setUri("/service-data-repository/entrepreneur/pagination/insurance/intervention")
                    .setOnRowClicked(row => navigate(route.ARTISAN_INSURANCE_INTERVENTION.replace(":token", row.intervention_token)))
                    .setFieldAsId("intervention_id")
                    .addFixedFilter("company_id", Operator.EQUALS, companyId)
                    .addFixedFilter("intervention_status", Operator.EQUALS, Intervention.STATUS_IN_PROGRESS)
                    .addFixedFilter("intervention_status", Operator.EQUALS, Intervention.STATUS_COMPLETED)
                    .setHideToolbar(true)
                    .setOrderBy(OrderBy.ASC)
                    .setPerPage(5)
                    .addPaginationColumn(
                        new PaginationColumn()
                            .setHeader("Dossier")
                            .setField("order_id")
                            .setType(Type.NUMBER)
                            .setDisableSearchOption(true)
                            .setDefaultWidth(0.1)
                    )
                    .addPaginationColumn(
                        new PaginationColumn()
                            .setHeader("Étape")
                            .setField("intervention_current_step")
                            .setValueCompiler(row => InterventionUtils.getCurrentStepAsBadge(row.intervention_current_step, "small"))
                            .setType(Type.ENUM)
                            .setEnumConfig(
                                new EnumConfig()
                                    .setMultiple(true)
                                    .addOption(new EnumOption(Intervention.STEP_INITIALIZED, InterventionUtils.getCurrentStepAsText(Intervention.STEP_INITIALIZED)))
                                    .addOption(new EnumOption(Intervention.STEP_QUOTATION_APPOINTMENT, InterventionUtils.getCurrentStepAsText(Intervention.STEP_QUOTATION_APPOINTMENT)))
                                    .addOption(new EnumOption(Intervention.STEP_TRAVEL, InterventionUtils.getCurrentStepAsText(Intervention.STEP_TRAVEL)))
                                    .addOption(new EnumOption(Intervention.STEP_PICTURE_BEFORE, InterventionUtils.getCurrentStepAsText(Intervention.STEP_PICTURE_BEFORE)))
                                    .addOption(new EnumOption(Intervention.STEP_QUOTATION, InterventionUtils.getCurrentStepAsText(Intervention.STEP_QUOTATION)))
                                    .addOption(new EnumOption(Intervention.STEP_QUOTATION_FAIRFAIR_VALIDATION, InterventionUtils.getCurrentStepAsText(Intervention.STEP_QUOTATION_FAIRFAIR_VALIDATION)))
                                    .addOption(new EnumOption(Intervention.STEP_QUOTATION_PRESCRIBER_VALIDATION, InterventionUtils.getCurrentStepAsText(Intervention.STEP_QUOTATION_PRESCRIBER_VALIDATION)))
                                    .addOption(new EnumOption(Intervention.STEP_QUOTATION_SIGNATURE, InterventionUtils.getCurrentStepAsText(Intervention.STEP_QUOTATION_SIGNATURE)))
                                    .addOption(new EnumOption(Intervention.STEP_WORKS_APPOINTMENT, InterventionUtils.getCurrentStepAsText(Intervention.STEP_WORKS_APPOINTMENT)))
                                    .addOption(new EnumOption(Intervention.STEP_WORKS, InterventionUtils.getCurrentStepAsText(Intervention.STEP_WORKS)))
                                    .addOption(new EnumOption(Intervention.STEP_PICTURE_AFTER, InterventionUtils.getCurrentStepAsText(Intervention.STEP_PICTURE_AFTER)))
                                    .addOption(new EnumOption(Intervention.STEP_REPORT_COMPLETION, InterventionUtils.getCurrentStepAsText(Intervention.STEP_REPORT_COMPLETION)))
                                    .addOption(new EnumOption(Intervention.STEP_REPORT_COMPLETION_SIGNATURE, InterventionUtils.getCurrentStepAsText(Intervention.STEP_REPORT_COMPLETION_SIGNATURE)))
                            )
                            .setDefaultWidth(0.2)
                    )
            }
        />
    )
}
